import './Atelier.css';

const Atelier = () => {

  return (
    <div class="max-h-[calc(100vh-86px)] overflow-y-auto flex flex-col justify-between h-full">
        <main class="max-w-6xl mx-auto w-full px-4 py-12 flex-grow flex items-center">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 items-center w-full">
                <div class="bg-stone-200 w-full h-[350px] flex items-center justify-center text-stone-500 font-serif italic text-sm">
                    Foto dell'Atelier
                </div>
                <div class="space-y-4">
                    <span class="text-xs uppercase tracking-widest text-stone-400 font-semibold">Lo Spazio</span>
                    <h1 class="text-3xl font-serif tracking-wide">Un luogo dove il tempo si ferma</h1>
                    <p class="text-stone-600 text-sm leading-relaxed">
                        Situato nel cuore della città, il nostro atelier è un salotto d'altri tempi concepito per offrire un'esperienza sartoriale intima ed esclusiva. Accogliamo i nostri ospiti solo su appuntamento.
                    </p>
                    <div class="pt-2">
                        <a href='#contatti' className="button button--janus"><span>Prenota una visita</span></a>
                    </div>
                </div>
            </div>
        </main>
    </div>
  );
};

export default Atelier;
